import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { CardActions } from '../../user.model';
import { UserCardRequestFormData } from '../../forms/user-card-request-detail-form/user-card-request-detail-form.component';

@Component({
    selector: 'app-user-card-not-connected-request-detail-dialog',
    templateUrl: './user-card-not-connected-request-detail-dialog.component.html',
    styleUrls: ['./user-card-not-connected-request-detail-dialog.component.scss'],
})
export class UserCardNotConnectedRequestDetailDialogComponent implements OnDestroy {
    public destroy$ = new Subject();

    CardActions = CardActions;

    constructor(
        private dialogRef: MatDialogRef<UserCardNotConnectedRequestDetailDialogComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: UserCardRequestFormData,
    ) {}

    closeDialog(value?: boolean): void {
        this.dialogRef.close(value);
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
